import axios from './api';

const getList = (params: any) => (
  axios.request({
    method: 'GET',
    url: '/hourapp/getUserCaseList',
    params,
  })
);

export default getList;
